import { frontendURL } from '../../../../helper/URLHelper';
const SettingsContent = () => import('../Wrapper.vue');
const Index = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/addresses'),
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: SettingsContent,
      props: {
        headerTitle: 'ADDRESSES.PAGE_TITLE',
        icon: 'gps-icon',
      },
      children: [
        {
          path: '',
          name: 'addresses',
          component: Index,
          meta: {
            permissions: ['administrator', 'agent'],
          },
        },
      ],
    },
  ],
};
